import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  allApi,
  messages,
  postApi,
  postApiFile,
} from "../helpers/apiStructure";

const initialState = {
  getUsersData: [],
  usersBlank: [],
  getSettingsData: [],
  getSettingData: [],
  userWiseMessageList:[]
};

var baseUrl = process.env.REACT_APP_BASE_URL;

// if (window.location.host) {
//   baseUrl = window.location.protocol + "//" + window.location.host;
// }
//reset products list
export const resetProductList = createAsyncThunk(
  "resetProductList",
  async (data) => {
    return [];
  }
);
//resetUser list resetUserRecord
export const resetUserRecord = createAsyncThunk("resetUserRecord", async (data) => {
    return [];
  }
);
export const resetListRecord = createAsyncThunk(
  "resetListRecord",
  async (data) => {
    return [];
  }
);
// users manage
export const getUsers = createAsyncThunk("getUsers", async (body) => {
  const result = await postApi(`${baseUrl}/api/users`, "post", body);
  return result;
});
export const userUpdate = createAsyncThunk("userUpdate", async (body) => {
  const result = await postApi(`${baseUrl}/api/user/edit`, "post", body);
  await messages(result?.message, result?.status);
  return result;
});
//forgot password
export const sendVerificationCode = createAsyncThunk(
  "sendVerificationCode",
  async (body) => {
    const result = await postApi(`${baseUrl}/api/email/otp`, "post", body);
    await messages(result?.message, result?.status);
    return result;
  }
);
export const verifyOTP = createAsyncThunk("verifyOTP", async (body) => {
  const result = await postApi(
    `${baseUrl}/api/user/forgetPassword`,
    "post",
    body
  );
  await messages(result?.message, result?.status);
  return result;
});
export const passwordChanges = createAsyncThunk(
  "passwordChanges",
  async (body) => {
    const result = await postApi(
      `${baseUrl}/api/user/password/change`,
      "post",
      body
    );
    await messages(result?.message, result?.status);
    return result;
  }
);

// count 
export const count = createAsyncThunk("count", async (body) => {
  const result = await postApi(`${baseUrl}/api/user/update/msg/cnt`, "post", body);
  return result;
});
//Message
export const sendMessage = createAsyncThunk("sendMessage", async (body) => {
  const result = await postApiFile(`${baseUrl}/api/message`, "post", body);
  return result;
});
export const sendWhatsappTemp = createAsyncThunk("sendWhatsappTemp", async (body) => {
  const result = await postApi(`${baseUrl}/api/send/templatemessage`, "post", body);
  await messages(result?.message, result?.status);
  return result;
});
export const userWiseMessage = createAsyncThunk("userWiseMessage", async (body) => {
  const result = await postApi(`${baseUrl}/api/messages`, "post", body);
  return result;
});
// setting manage
export const addSetting = createAsyncThunk("addSetting", async (body) => {
  const result = await postApi(`${baseUrl}/api/setting/add`, "post", body);
  await messages(result?.message, result?.status);
  return result;
});
export const getSettings = createAsyncThunk("getSettings", async (data) => {
  const result = await allApi(`${baseUrl}/api/settings`, "get");
  return result;
});
export const getSetting = createAsyncThunk("getSetting", async (body) => {
  const result = await postApi(`${baseUrl}/api/setting`, "post", body);
  return result;
});
export const getOpenSetting = createAsyncThunk("getOpenSetting", async (body) => {
  const result = await postApi(`${baseUrl}/api/settings/forcustomer`, "post", body);
  return result;
});
export const deleteSetting = createAsyncThunk("deleteSetting", async (data) => {
  const result = await allApi(`${baseUrl}/api/setting/${data}`, "delete");
  await messages(result?.message, result?.status);
  return result;
});
export const updateSetting = createAsyncThunk("updateSetting", async (body) => {
  const result = await postApi(
    `${baseUrl}/api/setting/edit/${body?.id}`,
    "put",
    body
  );
  await messages(result?.message, result?.status);
  return result;
});
//Email template
export const getWhatsappTemplate = createAsyncThunk(
  "getWhatsappTemplate",
  async (body) => {
    const result = await postApi(`${baseUrl}/api/template/list`, "post", body);
    return result;
  }
);
export const getWhatsappTemplateVarCount = createAsyncThunk("getWhatsappTemplateVarCount", async (body) => {
    const result = await postApi(`${baseUrl}/api/template`, "post", body);
    return result;
  }
);
export const addWhatsappTemplate = createAsyncThunk("addWhatsappTemplate", async (body) => {
    const result = await postApi(`${baseUrl}/api/template/add`, "post", body);
    await messages(result?.message, result?.status);
    return result;
  }
);
export const updateWhatsappTemplate = createAsyncThunk("updateWhatsappTemplate", async (body) => {
    const result = await postApi(`${baseUrl}/api/template/edit`, "post", body);
    await messages(result?.message, result?.status);
    return result;
  }
);
//login
export const adminLogin = createAsyncThunk("adminLogin", async (body) => {
  const result = await postApi(`${baseUrl}/auth/login`, "post", body);
  await messages(result?.message, result?.status);
  return result;
});
export const userLogOut = createAsyncThunk("userLogOut", async (body) => {
  const result = await postApi(
    `${baseUrl}/auth/logout`,
    "post",
    body,
    "Your are logout successfully."
  );
  await messages(result?.message, result?.status);
  return result;
});

const userReducer = createSlice({
  name: "details",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(resetUserRecord.fulfilled, (state) => {
        // state.getUsersData = [];
      })
      .addCase(resetListRecord.fulfilled, (state) => {
        state.userWiseMessageList = [];
      })
      .addCase(getUsers.fulfilled, (state, action) => {
        // state.getUsersData = [...state.getUsersData, ...action.payload?.list];
        state.getUsersData = action.payload?.list;
        state.usersBlank = action.payload?.list;
      })
      .addCase(userWiseMessage.fulfilled, (state, action) => {
        state.userWiseMessageList = [
          ...state.userWiseMessageList,
          ...action.payload?.list,
        ];
        state.userWiseMessageBlank = action.payload?.list;
        state.customerLastMsgTime = action.payload?.lastMsgTime;
      })
      .addCase(sendVerificationCode.fulfilled, (state, action) => {
        if (action.payload?.status === 1) {
          localStorage.setItem("sendVerificationCode", action.payload.status);
        }
      })
      .addCase(verifyOTP.fulfilled, (state, action) => {
        if (action.payload?.status === 1) {
          localStorage.setItem("verifyOTP", action.payload.status);
        }
      })
      .addCase(passwordChanges.fulfilled, (state, action) => {
        if (action.payload?.status === 1) {
          localStorage.setItem("passwordChanges", action.payload.status);
        }
      })
      .addCase(getSettings.fulfilled, (state, action) => {
        state.getSettingsData = action.payload;
      })
      .addCase(getSetting.fulfilled, (state, action) => {
        state.getSettingData = action.payload;
      })
      .addCase(getOpenSetting.fulfilled, (state, action) => {
        state.getSettingData = action.payload;
      })
      .addCase(getWhatsappTemplate.fulfilled, (state, action) => {
        state.whatsappTemplateList = action.payload.list;
      })
      .addCase(getWhatsappTemplateVarCount.fulfilled, (state, action) => {
        state.whtspVarCount = action.payload.inputDetails;
      })
      .addCase(adminLogin.fulfilled, (state, action) => {
        if (action.payload.status === 1) {
          localStorage.setItem("x-auth-token", action.payload.token);
          localStorage.setItem("userRole", action.payload?.me?.role?.name);
          localStorage.setItem("slug", action.payload?.me?.role?.slug);
          localStorage.setItem("username", action.payload?.me?.email);
          if (action.payload?.me?.pcdealUserAddressid) {
            localStorage.setItem(
              "pcdealUserAddressid",
              action.payload.me.pcdealUserAddressid
            );
          }
        }
      });
  },
});

export const { increaseLocalItem } = userReducer.actions;
export default userReducer.reducer;
